'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' });

var OpenInNew = function OpenInNew(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

OpenInNew = (0, _pure2.default)(OpenInNew);
OpenInNew.muiName = 'SvgIcon';

exports.default = OpenInNew;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/OpenInNew.js
// module id = 2661
// module chunks = 0